import { checkNotBlank } from 'vcomponents/forms/rules/Rules'

/**
 * Listing of companyForm
 * @returns {}
 */
 const defaultCompanyRules = () => {
    return {
        name: [
            { required: true, message:  window.i18n.__('Veuillez renseigner le nom de la société') , trigger: 'submit' },
            { validator: checkNotBlank, trigger: 'submit' },
        ],
        email: [
            { required: false, type: 'email',message : window.i18n.__('Veuillez renseigner une adresse email'), trigger: 'blur' },
            { pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w+)+$/, message : window.i18n.__('Veuillez renseigner une adresse email valide'), trigger: 'blur' },
        ],
        website: [
            { required: false, message: window.i18n.__("Veuillez renseigner l'URL"), trigger: 'blur' },
            { min: 4, pattern: /^\S+\.\S+$/ , message: window.i18n.__("L'URL est invalide") },
        ],
        phone: [
            { required: false, message: window.i18n.__('Veuillez renseigner un numéro de téléphone') },
            { min: 4, message: window.i18n.__('Veuillez renseigner un numéro de téléphone valide') },
        ],
        mobile: [
            { required: false, message: window.i18n.__('Veuillez renseigner un numéro de téléphone mobile') },
            { min: 4, message: window.i18n.__('Veuillez renseigner un numéro de téléphone mobile valide') },
        ],
        fax: [
            { required: false, message: window.i18n.__('Veuillez renseigner un numéro de fax') },
            { min: 4, message: window.i18n.__('Veuillez renseigner un numéro de fax valide') },
        ],
    }
}

const defaultCompanyState = () => {
    return {
        id: null,
        smartTagsType: "third",
        modulesSearch: false,
        listings:{
            contactsList: [],
            companiesList: [],
            types: [],
            businessSegmentsList: [],
            employeesNumber: [],
            accountingCodes : [],
            accountingPurchaseCodes: [],
            rateCategories: [],
            syncProviders : [],
            addressTypeList:[
                {value: 'invoice-delivery', label:  window.i18n.__("Facturation & Livraison"), disable : true},
                {value: 'invoice', label:  window.i18n.__('Facturation'), disable : false},
                {value: 'delivery', label:  window.i18n.__('Livraison'), disable : false},
                {value: 'other', label:  window.i18n.__('Autre'), disable : false}
            ],
        },
        companySettings: {
            name: "",
            type: 'prospect',
            email: null,
            website: null,
            numberOfEmployees: {value: null},
            businessSegments: {value: null},
            contactNumber:{
                phone: null,
                mobile:null,
                fax:null,
            },
            reference: null,
        },
        legalSettings: {
            capital: null,
            legalFrance: {
                siret: null,
                siren: null,
                vat: null,
                apeNafCode: null,
                companyType: null,
                rcsImmatriculation: null
            },
        },
        accounting:{
            accountingEnabled: true,
            useThirdAux: false,
            auxiliaryCode: '',
            accountingCodeId: null,
            accountingPurchaseCodeId: null,
        },
        contacts: [],
        paramsSettings: {
            rateCategories: {value: null},
            lang: 'fr',
            note: '',
            syncProviders: [],
            smartTags: [],
            social: {
                facebook: null,
                twitter: null,
                linkedin: null
            }
        }
    }
}

/**
 * Format of third data form client API
 * @param {*} state 
 * @returns 
 */
const persistCompany = (state) =>{
    
    // add Hypertext Transfer Protocol if doesn't exist.
    let url = state.companySettings.website;
    if(!_.isNil(url) && url !== ""){
        if(!url.match(/^(?:https?\:\/\/)?\S+\.\S+$/)){
            url = `http://${url}`;
        }
    }
    let persistedData = {
        //main
        type : state.companySettings.type,
        name : state.companySettings.name,
        email : state.companySettings.email,
        website : url,
        number_of_employees : state.companySettings.numberOfEmployees.value,
        business_segment: state.companySettings.businessSegments.value,
        phone_number : state.companySettings.contactNumber.phone,
        mobile_number : state.companySettings.contactNumber.mobile,
        fax_number : state.companySettings.contactNumber.fax,
        reference : state.companySettings.reference,
        
        ...persistLegalSettings(state.legalSettings),
        
        //params
        note : state.paramsSettings.note,
        rate_category_id : state.paramsSettings.rateCategories.value,
        social : state.paramsSettings.social,
        
        is_archived: false,

        //accounting
        auxiliary_code: state.accounting.auxiliaryCode,
        accounting_code_id :  parseInt(state.accounting.accountingCodeId),
        accounting_purchase_code_id :  parseInt(state.accounting.accountingPurchaseCodeId),

    }
    return persistedData;
}

/**
 * Format of third data form client API (only used when save company through Create Third popup)
 * @param {*} state 
 * @returns 
 */
 const persistCompanyShorten = (company) =>{
    let persistCompany  = {
        name : company.name,
    }
    
    if(company.legalSettings) {
        //legal
        persistCompany = {...persistCompany, ...persistLegalSettings(company.legalSettings)};
    } 
    if(company.created) { persistCompany.type = company.type; }

    return persistCompany;
}

const persistLegalSettings = (company) => {
    return {
        legal_france:{
            siret: company?.legalFrance?.siret || null,
            siren: company?.legalFrance?.siren || null,
            vat: company?.legalFrance?.vat || null,
            ape_naf_code: company?.legalFrance?.apeNafCode || null,
            company_type: company?.legalFrance?.companyType|| null,
            rcs_immatriculation: company.legalFrance?.rcsImmatriculation || null
        },
        capital : company?.capital || null,
    }
}

export {
    persistCompany,
    persistCompanyShorten,
    defaultCompanyState,
    defaultCompanyRules,
}